import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=41cc1bfa&"
import script from "./Feedback.js?vue&type=script&lang=js&"
export * from "./Feedback.js?vue&type=script&lang=js&"
import style0 from "./Feedback.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports